"use client"

import React, { useState, useEffect } from "react"
import { Filter, X } from "lucide-react"
import FilterBar from "./FilterBar"
import { useSearchParams } from "next/navigation"

export default function MobileFilter() {
	const [isOpen, setIsOpen] = useState(false)
	const searchParams = useSearchParams()

	// 监听参数变化，在移动端选择筛选后自动关闭（可选体验）
	useEffect(() => {
		// setIsOpen(false) // 开启后每次点击筛选都会关闭，如果不希望这样可以注释掉
	}, [searchParams])

	return (
		<div className="md:hidden">
			{/* Floating Filter Button */}
			<button 
				onClick={() => setIsOpen(true)}
				className="fixed bottom-8 left-6 z-[60] btn btn-primary btn-circle shadow-2xl scale-110 border-2 border-white/20"
			>
				<Filter size={24} />
			</button>

			{/* Filter Drawer / Modal */}
			{isOpen && (
				<div className="fixed inset-0 z-[70] flex items-end justify-center">
					{/* Overlay */}
					<div 
						className="absolute inset-0 bg-black/60 backdrop-blur-md animate-in fade-in duration-300"
						onClick={() => setIsOpen(false)}
					/>
					
					{/* Content Container */}
					<div 
						className="relative w-full max-h-[85vh] bg-base-100 rounded-t-[3rem] p-8 shadow-2xl border-t border-white/10 overflow-y-auto animate-in slide-in-from-bottom duration-500"
					>
						{/* Handle bar for visual */}
						<div className="w-12 h-1.5 bg-base-300 rounded-full mx-auto mb-8 opacity-50" />
						
						<div className="flex justify-between items-center mb-8">
							<h2 className="text-2xl font-black">Filter Showcase</h2>
							<button 
								onClick={() => setIsOpen(false)} 
								className="btn btn-ghost btn-circle btn-sm"
							>
								<X size={24} />
							</button>
						</div>

						<FilterBar hideTitle className="pb-10" />
					</div>
				</div>
			)}
		</div>
	)
}

